import React from "react"
import {
	Box,
	Grid,
	Dialog,
	Button,
	IconButton,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	useTheme,
} from "@mui/material"
import Link from "components/i18n/Link"

import Icon from "@mdi/react"
import { mdiHelpCircle, mdiClose } from "@mdi/js"

const LockingInformationDialog = () => {
	const [open, setOpen] = React.useState(false)
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down("lg"))

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}
	return (
		<>
			<Box mt={1} mb={-1}>
				<div style={{ display: "flex", alignItems: "center" }}>
					<Box mr={-1}>
						<strong>Schließmechanismus wählen</strong>
					</Box>
					<IconButton onClick={handleClickOpen} size="large">
						<Icon path={mdiHelpCircle} size={0.8} color="#4691CE" />
					</IconButton>
				</div>
				<Dialog
					fullScreen={fullScreen}
					open={open}
					onClose={handleClose}
					maxWidth={"md"}
					aria-labelledby="zylinder-messen"
				>
					<DialogTitle
						id="zylinder-messen-dialog"
						style={{
							borderBottom: "1px solid #B8BCBF",
						}}
					>
						<div>
							<strong>Schließmechanismen</strong>
						</div>
						<Button
							onClick={handleClose}
							color="primary"
							style={{ position: "absolute", top: 13, right: 10 }}
						>
							<Icon path={mdiClose} size={1} />
						</Button>
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Box mb={3}>
									Möchten Sie mehr als einen Zylinder bestellen, können diese auch
									gleichschließend geliefert werden. Wird nur ein Zylinder
									benötigt, wählen Sie bitte Einzelschließend.
								</Box>
							</Grid>
						</Grid>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<div>
									<strong>Einzelschließend</strong>
								</div>
								<p>
									Der Zylinder/das Schloss erhält seine{" "}
									<strong>eigene Schließung</strong> und kann{" "}
									<strong>nur durch die konfigurierten Schlüssel</strong> gesperrt
									werden (=Verschiedenschließend). Jeder Zylinder wird mit einer
									eigenen Sicherungskarte geliefert.
								</p>
							</Grid>
							<Grid item xs={12}>
								<div>
									<strong>Gleichschließend</strong>
								</div>
								<p>
									<strong>
										Alle Zylinder einer Bestellung können mit allen Schlüsseln
										der Bestellung
									</strong>{" "}
									gesperrt werden. Dies ist für alle erhältlichen
									Zylinderausführungen und Schlösser eines Systems möglich. Für
									die gesamte Bestellung wird eine Sicherungskarte mitgeliefert.
								</p>
								<p>
									Für individuelle Schließungen und Schließanlagen empfehlen wir
									die Nutzung des{" "}
									<Link href="/locking-system">Schließanlagenplaner</Link>
								</p>
							</Grid>
						</Grid>
					</DialogContent>
				</Dialog>
			</Box>
		</>
	)
}

export default LockingInformationDialog
